import * as React from "react";
import type { SVGProps } from "react";
const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#eye_svg__a)">
      <path d="M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      <path d="M12 19c-4.5 0-8-3.36-9.87-6.5a1 1 0 0 1 0-1C4 8.36 7.5 5 12 5s8.05 3.36 9.87 6.5a1 1 0 0 1 0 1C20.05 15.64 16.5 19 12 19m-7.83-7c1.56 2.41 4.42 5 7.83 5s6.27-2.59 7.83-5C18.27 9.59 15.41 7 12 7s-6.27 2.59-7.83 5" />
    </g>
    <defs>
      <clipPath id="eye_svg__a">
        <path fill="#fff" d="M2 5h20v14H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEye;
